<div class="page-container">
  <div class="border-b p-4">
    <a routerLink="/blog" class="font-medium">
      <i class="app-icon-chevron-left align-middle"></i> Blog
    </a>
  </div>

  <div class="py-24">
    <div class="blog-post-container container mx-auto max-w-4xl">
      <div *ngIf="loading">
        <div
          class="text-center"
          appLoader
          [loading]="true"
          loaderColor="dark"
          [loaderWidth]="50"
        ></div>
      </div>

      <div
        *ngIf="post"
        class="blog-post"
        [style.backgroundImage]="
          post.header_background_image?.url
            ? 'url(' + post.header_background_image?.url + ')'
            : null
        "
      >
        <article
          class="container mx-auto max-w-3xl"
          itemscope
          itemtype="http://schema.org/Article"
        >
          <div class="px-4 text-center">
            <a *ngIf="post?.slug" [routerLink]="post.route">
              <h1
                class="text-3xl font-medium leading-normal text-black sm:text-4xl md:text-5xl md:leading-[125%]"
                [innerHTML]="post.title?.rendered | appSafeHtml"
              ></h1>
            </a>

            <p class="mt-4 text-neutral-600">
              <span *ngIf="post.authors?.length">
                <span *ngFor="let author of post.authors; let last = last">
                  <a
                    class="text-neutral-600 hover:text-neutral-800 hover:underline"
                    [routerLink]="['/blog']"
                    [queryParams]="{ author: author.id }"
                    >{{ author.name }}</a
                  >
                  <span *ngIf="!last">, </span>
                </span>
                |
              </span>
              <span>
                {{ post.timestamp }}
              </span>
            </p>
          </div>

          <div
            class="prose max-w-3xl px-4 py-12 text-lg lg:px-0"
            style="--tw-prose-body: black"
            [innerHTML]="post.content?.rendered | appLoadScripts | appSafeHtml"
          ></div>
        </article>

        <div
          *ngIf="relatedProducts?.length"
          class="mt-8 space-y-4 border-y p-4 lg:py-12 lg:px-8"
        >
          <h3>Gear in this post</h3>

          <div class="mx-auto max-w-2xl">
            <div *ngFor="let product of relatedProducts" class="mt-8">
              <app-product-detail-card
                [product]="product"
                [displayDescription]="true"
              >
              </app-product-detail-card>
            </div>
          </div>
        </div>

        <div *ngIf="relatedPost" class="mt-8">
          <div class="mx-auto mt-4 max-w-3xl rounded border">
            <div class="p-4 lg:p-8">
              <h3>Comments</h3>
              <div class="mt-4">
                <app-comment-form
                  placeholder="Share your thoughts"
                  [commentableId]="relatedPost.id"
                  commentableType="posts"
                  (added)="onCommentAdded($event)"
                >
                </app-comment-form>
              </div>
            </div>

            <div class="mt-4">
              <app-comments
                #comments
                [commentable]="relatedPost"
              ></app-comments>
            </div>
          </div>
        </div>

        <div
          *ngIf="post?.categories?.length || post?.tags?.length"
          class="mt-8 border-t px-4 pt-8 lg:px-0"
        >
          <div *ngIf="post.categories?.length">
            <div class="p-1 text-sm text-gray-600">Posted in:</div>

            <div class="mt-2 flex flex-wrap">
              <div *ngFor="let category of post.categories" class="p-1">
                <a
                  class="inline-block whitespace-nowrap rounded border border-gray-400 bg-white p-2 text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                  [routerLink]="category.route"
                  [queryParams]="category.routeQueryParams"
                >
                  {{ category.name }}
                </a>
              </div>
            </div>
          </div>

          <div *ngIf="post.tags?.length" class="mt-8">
            <div class="p-1 text-sm text-gray-600">Tagged with:</div>

            <div class="mt-2 flex flex-wrap">
              <div *ngFor="let tag of post.tags" class="p-1">
                <a
                  class="inline-block whitespace-nowrap rounded border border-gray-400 bg-white p-2 text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                  [routerLink]="tag.route"
                  [queryParams]="tag.routeQueryParams"
                >
                  {{ tag.name }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="similarPosts?.length"
          class="mt-8 border-t px-4 pt-8 lg:px-0"
        >
          <h2 class="text-2xl">Similar Posts</h2>

          <div class="mt-8 space-y-12">
            <article
              *ngFor="let post of similarPosts"
              itemscope
              itemtype="http://schema.org/Article"
            >
              <a
                class="block overflow-hidden rounded-lg border bg-white hover:bg-gray-50"
                [routerLink]="post.route"
              >
                <div class="flex flex-col sm:flex-row sm:items-stretch">
                  <div
                    *ngIf="post.featured_image"
                    class="aspect-w-16 aspect-h-9 sm:aspect-w-6 sm:aspect-h-2 shrink-0 bg-gray-50 sm:w-1/4 sm:border-r md:w-1/3"
                  >
                    <img
                      class="h-full w-full object-cover sm:h-full sm:w-full"
                      [src]="
                        post.featured_image?.media_details?.sizes?.large
                          ?.source_url
                      "
                      alt="{{ post.title?.rendered }}"
                    />
                  </div>

                  <div class="p-8">
                    <h3
                      class="text-black"
                      [innerHTML]="post.title?.rendered | appSafeHtml"
                    ></h3>

                    <div class="text-neutral-600">
                      {{ post.timestamp }}
                    </div>

                    <div
                      class="line-clamp-3 mt-2 text-black"
                      [innerHTML]="post.excerpt?.rendered | appSafeHtml"
                    ></div>
                  </div>
                </div>
              </a>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<meta itemprop="dateCreated" [attr.content]="post?.date | date: 'yyyy-MM-dd'" />

<meta
  itemprop="dateModified"
  [attr.content]="post?.modified | date: 'yyyy-MM-dd'"
/>

<meta
  *ngIf="post?.featured_image"
  itemprop="image"
  [attr.content]="
    post?.featured_image?.media_details?.sizes
      ? post?.featured_image?.media_details?.sizes?.large?.source_url
      : post?.featured_image?.source_url
  "
/>
